export function startQuickPay10PaymentWindow(paymentVars: any) {
    const url = paymentVars.url;
    window.location = url;
}